import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import ImageView from 'lib/images/responsive-image-view';

import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';

import defaultStyles from './author-side-collections.scss';
import { AuthorCollectionsFragment } from './author-side-collections.graphql';

export interface Props extends AuthorCollectionsFragment {
    styles: typeof defaultStyles;
}

function AuthorSideCollections(props: Props) {
    const { styles, profile, photoBlog } = props;

    const collections = photoBlog && photoBlog.collections && photoBlog.collections.edges;

    if (collections === null || collections.length <= 0 || (profile && profile.isVendor)) {
        return null;
    }

    return (
        <div className={styles.collections}>
            <div className={styles.sectionTitle}>
                <FormattedMessage id='COLLECTIONS' />
            </div>
            <ul className={styles.collectionList}>
                {collections.map(edge => {
                    const collection = edge && edge.node;
                    if (collection && collection.href && collection.images && collection.images.edges) {
                        return (
                            <li className={styles.collectionItem} key={collection.id}>
                                <Link className={styles.collectionLink} to={collection.href}>
                                    <div className={styles.collectionImages}>
                                        {collection.images.edges.map(imgEdge =>
                                            imgEdge &&
                                            imgEdge.node &&
                                            imgEdge.node.image &&
                                            imgEdge.node.image.photoFile &&
                                            imgEdge.node.image.photoFile.srcset ? (
                                                <div key={imgEdge.node.id}>
                                                    <ImageView
                                                        linkify={false}
                                                        aspectFill={true}
                                                        srcSet={imgEdge.node.image.photoFile.srcset}
                                                        src={imgEdge.node.image.photoFile.src}
                                                    />
                                                </div>
                                            ) : null
                                        )}
                                    </div>
                                    <span className={styles.collectionTitle}>
                                        <TextShortener text={collection.title} textLength={22} />
                                    </span>
                                </Link>
                            </li>
                        );
                    }
                    return null;
                })}
            </ul>
        </div>
    );
}

export default Styled(defaultStyles)(AuthorSideCollections);
